import { render, staticRenderFns } from "./edit-discuss-modal.vue?vue&type=template&id=d69c6fdc&scoped=true"
import script from "./edit-discuss-modal.vue?vue&type=script&lang=js"
export * from "./edit-discuss-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-discuss-modal.vue?vue&type=style&index=0&id=d69c6fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69c6fdc",
  null
  
)

export default component.exports